module.exports = __webpack_public_path__ + "static/media/pantalla_vertical.af7984bd.png";